import { useState } from "react";
import { openSSODialog } from "../lib/sso";

export function Login() {
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function sso() {
    setBusy(true);
    setError(null);
    try {
      await openSSODialog();
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex h-full items-center justify-center p-6">
      <div className="w-full max-w-xs space-y-4">
        <div>
          <h1 className="text-base font-semibold">Pontifexx AI</h1>
          <p className="text-xs text-muted-fg">Log in met je Pontifexx Microsoft account.</p>
        </div>
        <button
          onClick={sso}
          disabled={busy}
          className="flex w-full items-center justify-center gap-2 rounded bg-primary px-3 py-2.5 text-sm text-primary-fg disabled:opacity-50"
        >
          <svg className="h-4 w-4" viewBox="0 0 448 512" aria-hidden="true">
            <path
              fill="currentColor"
              d="M0 32h214.6v214.6H0V32zm233.4 0H448v214.6H233.4V32zM0 265.4h214.6V480H0V265.4zm233.4 0H448V480H233.4V265.4z"
            />
          </svg>
          {busy ? "Bezig…" : "Inloggen met Single Sign On"}
        </button>
        {error && <p className="text-xs text-destructive">{error}</p>}
      </div>
    </div>
  );
}
